import { TourConfig } from '../types';
import { END2_RESTART_BUTTON, END2_SPEECH_BUBBLE } from './end2';

export const GUIDED_JOURNEY_ENDED_ID = 'guidedJourneyEnded';

/**
 * The persistent post-tour banner. Non-exclusive and low priority, so habitat/events
 * onboardings win on their own pages while this still surfaces wherever nothing else is
 * competing. Eligible only while the journey stays completed, so restarting removes it.
 */
export const guidedJourneyEndedConfig: TourConfig = {
  id: GUIDED_JOURNEY_ENDED_ID,
  steps: [
    {
      id: 'End2',
      ui: {
        banner: {
          type: 'guide',
          mascot: 'talking',
          speechBubble: END2_SPEECH_BUBBLE,
          buttons: [{ label: 'Revisit the animals on my own', navigatePath: '/home' }, { ...END2_RESTART_BUTTON }],
        },
      },
    },
  ],
};
